var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"qr_dialog"},[_c('QrIframe',{attrs:{"url":_vm.url,"height":_vm.height}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }